import { civilUnionAddressNameFields } from 'constants/enums/people';
import {
  maritalStatusOptions,
  marriedOptions,
  maritalStatusOptionsPvq,
  marriedOptionsPvq,
  previouslyMarriedOptions,
  NEVER_MARRIED,
  FATHER_IN_LAW,
  MOTHER_IN_LAW,
} from 'constants/enums/relationshipOptions';
import { ValidateJSModel } from 'forms/shared/types';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { isPVQForm } from 'helpers/form';
import { RelationshipsMaritalModel } from './types';
import { relationshipsMaritalCivilUnionValidator } from './validators/fields';
import { relationshipsMaritalDivorceItemValidator } from './validators/item';

const relationshipsMaritalValidator: ValidateJSModel<RelationshipsMaritalModel> = {
  Status: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: maritalStatusOptionsPvq,
          },
        }
      };
    }
    if (value?.value === NEVER_MARRIED && options?.relativesList) {
      const currentRelativesList = options?.relativesList;
      for (let index = 0; index < currentRelativesList.length; index++) {
        if (currentRelativesList[index].Item?.Relation?.value === MOTHER_IN_LAW
          || currentRelativesList[index].Item?.Relation?.value === FATHER_IN_LAW) {
          return {
            hasValue: {
              validator: {
                exclusion:
                {
                  within: [NEVER_MARRIED],
                  message: 'error.invalidMaritalRelationInlaws',
                },
              }
            }
          };
        }
      }
    }

    return {
      hasValue: {
        validator: {
          inclusion: maritalStatusOptions,
        },
      }
    };
  },

  CivilUnion: (value, attributes, attributeName, options) => {
    let additionalValidation = {};
    const { errors = [] } = getDuplicateNamesAndAddresses([value], options?.peopleWhoKnowYou, civilUnionAddressNameFields);

    if (errors.length > 0) {
      additionalValidation = {
        requireTrue: { // force error message; value will never be true
          message: 'relationships.relatives.error.duplicateListItems',
        }
      };
    }

    if (isPVQForm(options?.formType)) {
      if (attributes?.Status?.value && marriedOptionsPvq.includes(attributes?.Status.value)) {
        return {
          ...additionalValidation,
          presence: true,
          model: {
            validator: relationshipsMaritalCivilUnionValidator,
          },
        };
      }

      return {};
    }

    if (attributes?.Status?.value && marriedOptions.includes(attributes?.Status.value)) {
      return {
        ...additionalValidation,
        presence: true,
        model: {
          validator: relationshipsMaritalCivilUnionValidator,
        },
      };
    }

    return {};
  },
  DivorcedList: (value, attributes, attributeName, options) => {
    // Required if Status is a previously married value
    // OR if Status is a currently married value, AND CivilUnion.Divorced is "Yes"
    if (
      attributes?.Status?.value
      && (previouslyMarriedOptions.includes(attributes?.Status.value)
        || (marriedOptions.includes(attributes?.Status.value)
          && attributes?.CivilUnion?.Divorced?.value === 'Yes'))
    ) {
      return {
        presence: true,
        accordion: {
          validator: relationshipsMaritalDivorceItemValidator,
        },
      };
    }

    if (isPVQForm(options?.formType)) {
      if (
        attributes?.Status?.value
        && (previouslyMarriedOptions.includes(attributes?.Status.value)
          || (marriedOptionsPvq.includes(attributes?.Status.value)
            && attributes?.CivilUnion?.Divorced?.value === 'Yes'))
      ) {
        return {
          presence: true,
          accordion: {
            validator: relationshipsMaritalDivorceItemValidator,
          },
        };
      }
    }

    return {};
  },
  DivorcedComments: {},
  DivorcedSummaryComments: {},
};

export default relationshipsMaritalValidator;
